// dependencies
import { fromJS } from "immutable";

const LoggerMiddleware = () => (next) => (action) => {
	/*
        I would like to maybe add some timing functions to this in the future.
    */

	let bgColor = "#404041";
	const { type = "UNNAMED ACTION" } = action;

	if (type.indexOf("@SUCCESS") >= 0) {
		bgColor = "#33bb66";
	} else if (type.indexOf("@FAIL") >= 0) {
		bgColor = "#e75353";
	} else if (type.indexOf("@START") >= 0) {
		bgColor = "#58BCC7";
	}

	// print a copy as a vanilla js object
	const actionCopy = fromJS(action).toJS();
	console.log("%c%s", `padding: 3px 4px; font-weight: 600; background: ${bgColor}; color: #fff`, type, actionCopy);

	/*
        next() passes an action to the next middleware, or to the
        reducer if there's no next middleware.
    */
	next(action);
};

export default LoggerMiddleware;
